import React, { Component } from 'react';
import { useContext, useEffect, useState } from "react";
import { Card, Accordion, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { CHAINS, frontendurl, AdminSaleAddress, API_URL, mainurl } from "../config/env";

import Walletmodal from "./Walletmodal";
import Settingsmodal from "./Settingsmodal";

// import 'font-awesome/css/font-awesome.min.css';

import { getAccount, getChainId, setChainId } from '../hooks/useAccount'


import { getProxyOwner } from '../hooks/useContract';
import { UseProvider } from '../hooks/useWeb3'


import homeicon from "../images/chainpad/presale.svg"
import coinsicon from "../images/coins.svg"
import exchangeicon from "../images/exchange.svg"
import kycicon from "../images/kyc.svg"

import teles from "../images/chainpad/teles.png";
import skypes from "../images/chainpad/twitter.png";

import launchpadicon from "../images/chainpad/rocket.svg"
import lockedicon from "../images/chainpad/inlock.svg"
import privateicon from "../images/chainpad/private.svg"
import createlaunch from "../images/chainpad/create.svg"
import utility from "../images/chainpad/utility.svg";
import docsicon from "../images/docs.svg"
import twittericon from "../images/twitter.svg"
import telegramicon from "../images/telegram.svg"
import discordicon from "../images/discord.svg";
import demoimg from "../images/chainpad/demo.png";
import leadershipicon from "../images/leadershipicon.png";
import sendericon from "../images/sendericon.png";



import bar_img_white from "../images/bar_img_white.png"

import airicon from "../images/chainpad/airdrop.svg";
import exchange from "../images/Bitdeal/exchange.svg"

import fbicon from "../images/fb.svg"





import { NavLink } from "react-router-dom";
import { getsettinghook, getcmshook } from '../hooks/usebackend';
import { MdOutlineMenu } from "react-icons/md";
import Sidebaraccordion from './Sidebaraccordion';

class Sidebar extends Component {

    darkTheme() {

        document.body.classList.remove('light_theme');
        document.body.classList.add('dark_theme');
        document.getElementById("sun_icon").classList.remove('active');
        document.getElementById("moon_icon").classList.add('active');
        // document.getElementById("sun_icon_mob").classList.remove('active'); 
        // document.getElementById("moon_icon_mob").classList.add('active'); 
        localStorage.setItem("theme", 'dark_theme');
    }
    lightTheme() {
        console.log("ent er tsadfasdf")
        document.body.classList.remove('dark_theme');
        document.body.classList.add('light_theme');
        document.getElementById("moon_icon").classList.remove('active');
        document.getElementById("sun_icon").classList.add('active');
        // document.getElementById("moon_icon_mob").classList.remove('active'); 
        // document.getElementById("sun_icon_mob").classList.add('active');
        localStorage.setItem("theme", 'light_theme');


    }





    // darkThemeMobile()
    // {
    //     document.body.classList.remove('light_theme'); 
    //     document.body.classList.add('dark_theme'); 

    //     document.getElementById("sun_icon_mob").classList.remove('active'); 
    //     document.getElementById("moon_icon_mob").classList.add('active'); 
    //     localStorage.setItem("theme",'dark_theme');


    // }
    // lightThemeMobile()
    // {
    //     document.body.classList.remove('dark_theme'); 
    //     document.body.classList.add('light_theme'); 

    //     document.getElementById("moon_icon_mob").classList.remove('active'); 
    //     document.getElementById("sun_icon_mob").classList.add('active');
    //     localStorage.setItem("theme",'light_theme');


    // }





    // showMobile()
    // {

    //     document.getElementById("mobile_nav_item").classList.toggle("left_stye");
    //     document.getElementById("mobileLayer").classList.toggle('active');
    //     document.getElementById("burger").classList.toggle('clicked');  
    //     document.getElementById("burger").classList.toggle("burger_stye")   

    // }







    constructor(props) {
        super(props);
        this.state = {
            themes: true,
            location: false,
            walletModal: false,
            accountInfo: "",
            walletConnect: "",
            proxyOwner: "",
            currentChain: 0,
            settingsModal: false,
            sidebarShrink: false,
            setActive: 0,
            setting: [],
            telegram: "",
            Docs: "",
            PresaleAlerts: "",
            Skype: "",
            joinAlpha: "",
            image: "",
            Twitter: ""

        }
    }

    setSidebarWidth() {
        this.setState({ sidebarShrink: !this.state.sidebarShrink });
        if (this.state.sidebarShrink) {
            document.body.classList.remove('sidebar_shr');
        }
        else {
            document.body.classList.add('sidebar_shr');

        }
    }

    componentDidMount() {
        document.body.classList.remove('sidebar_shr');
        let data = localStorage.getItem("theme");
        console.log("local data", data)
        if (data == "dark_theme") {
            this.darkTheme()
        } else if (data == "light_theme") {
            this.lightTheme()
        } else {
            this.darkTheme()
        }
        // if(!(localStorage.getItem("theme") == "dark_theme"))
        // {
        //     document.body.classList.remove('dark_theme'); 
        //     document.body.classList.add('light_theme'); 
        //     document.getElementById("moon_icon").classList.remove('active'); 
        //     document.getElementById("sun_icon").classList.add('active');
        //     document.getElementById("moon_icon_mob").classList.remove('active'); 
        //     document.getElementById("sun_icon_mob").classList.add('active');
        //     localStorage.setItem("theme",'light_theme');
        // }
        // else
        // {
        //     document.body.classList.remove('light_theme'); 
        //     document.body.classList.add('dark_theme'); 
        //     document.getElementById("sun_icon").classList.remove('active'); 
        //     document.getElementById("moon_icon").classList.add('active'); 
        //     document.getElementById("sun_icon_mob").classList.remove('active'); 
        //     document.getElementById("moon_icon_mob").classList.add('active');
        //     localStorage.setItem("theme",'dark_theme');  
        // }
        this.setState({ accountInfo: getAccount() });
        this.setState({ currentChain: getChainId() });
        this.getOwner();
        this.getsetting();
        this.getcms()
    }

    async getsetting() {
        let data = await getsettinghook();
        console.log("data setting", data?.data?.data);
        this.setState({ setting: data?.data?.data })
        data?.data?.data.length > 0 && data?.data?.data?.map((val, i) => {
            console.log("val", val)
            if (val.settingname == "Docs" || val.settingname == "docs") {
                this.setState({ Docs: val.settingvalue });
            }
            if (val.settingname == "Twitter" || val.settingname == "twitter") {
                this.setState({ Twitter: val.settingvalue });

            }
            if (val.settingname == "Telegram" || val.settingname == "telegram") {
                this.setState({ telegram: val.settingvalue });
            }
            if (val.settingname == "Presale Alerts" || val.settingname == "presale alerts") {
                this.setState({ PresaleAlerts: val.settingvalue });
            }
            if (val.settingname == "Join Alpha Club" || val.settingname == "join alpha club") {
                this.setState({ joinAlpha: val.settingvalue });
            }


        })
    }

    onDismiss() {
        this.setState({ walletModal: false });
    }

    getOwner = async () => {
        const owner = await getProxyOwner();
        this.setState({ proxyOwner: owner });

    }

    logOut = async () => {
        this.setState({ accountInfo: "" })
        localStorage.removeItem("accountInfo")
        if (localStorage.getItem("walletconnect") != null) {
            const provider = await UseProvider();
            await provider.disconnect()
        }
        //  this.setState({accountModal: false})
        window.location.reload()
        console.log("logout")
    }


    getcms = async () => {

        let cmscontent = await getcmshook();
        console.log("cmscontent", cmscontent);
        if (cmscontent?.data?.success == true) {
            this.setState({ "image": cmscontent?.data?.data[0].image });
            console.log("image", this.state.image)
        }

    }


    render() {
        const { location } = this.props;
        const { walletModal, accountInfo, settingsModal, sidebarShrink, setActive } = this.state


        return (

            <>
                <div id="sidebar" className={sidebarShrink ? "side_shrink" : ""}>
                    {/* <button className="get-started-btn rounded_btn_wal  shrink_side_btn" onClick={() => this.setSidebarWidth()}>
                        <img src={bar_img_white} className='img-fluid' />/
                      
                    </button> */}
                    {/* <i class="fa fa-chevron-right" aria-hidden="true"></i> */}


                    {/* <ul className='sidebar_ul'>
            <NavLink to="/" className="parent_1_grad">
                <li className='lis_paren_side li_bot_less'>
               
                <img src={homeicon} className="icon_sidebar" />
                <span>
                Presales
                </span>
               
                </li>

                
                </NavLink>
                </ul> */}
                    <ul className='sidebar_ul'>
                        
                        <div className='mobilefirst text-center'>
                            <div className='mb-2'>
                                <a href={`${mainurl}/`}  rel="noopener noreferrer"><span class="logo_img_sm mlogo"></span></a>
                                {/* <div>
                                    <NavLink to={`/bdagsale/${AdminSaleAddress}`}><button class="get-started-btn explore-btn mb-2">Buy BlockDAG</button></NavLink>
                                </div> */}
                            </div>

                          <Sidebaraccordion/>

                            {/* <div className='mobilealpha mb-4'>
                                <Link to="/home">
                                    <button className='btn get-started-btn blackbtn mt-2'> <svg xmlns="http://www.w3.org/2000/svg" width="17" height="18" viewBox="0 0 17 18" fill="none">
                                        <path d="M6.84745 17.75V11.75H10.1808V17.75H14.3475V9.75H16.8475L8.51412 0.75L0.180786 9.75H2.68079V17.75H6.84745Z" fill="white" />
                                    </svg> <span className='ml-1'>Home</span></button></Link>
                                <a href={this.state.Docs} target="_blank">
                                    <button className='btn get-started-btn blackbtn mt-2'> <svg xmlns="http://www.w3.org/2000/svg" width="21" height="24" viewBox="0 0 21 24" fill="none">
                                        <path d="M16.4875 3H4.82084C3.90417 3 3.15417 3.9 3.15417 5V19C3.15417 20.1 3.90417 21 4.82084 21H16.4875C17.4042 21 18.1542 20.1 18.1542 19V5C18.1542 3.9 17.4042 3 16.4875 3ZM12.3208 17H6.48751V15H12.3208V17ZM14.8208 13H6.48751V11H14.8208V13ZM14.8208 9H6.48751V7H14.8208V9Z" fill="white" />
                                    </svg> <span className='ml-1'>Docs</span></button></a>
                                <a href={this.state.PresaleAlerts} target="_blank">
                                    <button className='btn get-started-btn blackbtn mt-2'> <svg xmlns="http://www.w3.org/2000/svg" width="21" height="24" viewBox="0 0 21 24" fill="none">
                                        <path d="M8.80417 18.65L9.0375 14.42L15.4375 7.5C15.7208 7.19 15.3792 7.04 15.0042 7.31L7.10417 13.3L3.6875 12C2.95417 11.75 2.94584 11.14 3.85417 10.7L17.1625 4.54C17.7708 4.21 18.3542 4.72 18.1208 5.84L15.8542 18.65C15.6958 19.56 15.2375 19.78 14.6042 19.36L11.1542 16.3L9.49584 18.23C9.30417 18.46 9.14584 18.65 8.80417 18.65Z" fill="white" />
                                    </svg> <span className='ml-1'>Presale Alerts</span></button></a>
                              
                            </div> */}
                        </div>

                        {/* <div className='buychainbtn'>
                        <NavLink to={`/bdagsale/${AdminSaleAddress}`}><button class="get-started-btn explore-btn mb-3">Buy Chainpad</button></NavLink>
                        </div> */}

                     

                        <NavLink to="/"
                            className="firstactive"
                            id="home_grad_aprent"
                        >
                           
                        </NavLink>

                        


                        {/* <NavLink to={`/bdagsale/${AdminSaleAddress}`}
                            className="firstactive "
                            id="home_grad_aprentchainpad"
                        >
                            <li className='lis_paren_side li_bot_less'>
                                <img src={privateicon} className="icon_sidebar" />
                                <span>
                                    BlockDAG Token
                                </span>

                            </li>
                        </NavLink> */}

                        

                        <li className='px-0 py-0 li_bot_less d-none'>
                            <Accordion>

                                <Card>
                                    <Card.Header className='lis_paren_side_accordion px-0 py-2' id="launchpad_parent">
                                        <Accordion.Toggle as={Button} variant="link" eventKey="0" className='w-100 pl-0' >
                                            <div className='d-flex align-items-center justify-content-between pl-0' >
                                                <div className='icon_text_div pl-2' >
                                                    <img src={launchpadicon} className="icon_sidebar" />
                                                    <span>
                                                        Launchpad
                                                    </span>
                                                </div>
                                                <button className='btn_white_outline_round'>
                                                    <i class="fa fa fa-angle-down" aria-hidden="true"></i>
                                                </button>
                                            </div>

                                        </Accordion.Toggle>
                                    </Card.Header>
                                    <Accordion.Collapse eventKey="0">
                                        <Card.Body className='py-0 inner_card_body_acc'>
                                            <ul className='sidebar_inner_ul pl-3'>
                                                <NavLink to="/create" onClick={() => { this.setState({ setActive: 1 }) }}>
                                                    <li className='li_bot_less'>
                                                        Create Launchpad
                                                    </li>
                                                </NavLink>
                                                <NavLink to="/createfairlaunch">
                                                    <li className='li_bot_less'>

                                                        Create Fair Launch

                                                    </li>
                                                </NavLink>
                                                <NavLink to="/launchpadlist">
                                                    <li className='li_bot_less'>

                                                        Launchpad List

                                                    </li>
                                                </NavLink>
                                                <NavLink to="/createtoken">
                                                    <li className='li_bot_less'>

                                                        Token Creation

                                                    </li>
                                                </NavLink>
                                            </ul>
                                        </Card.Body>
                                    </Accordion.Collapse>
                                </Card>

                                <Card>
                                    <Card.Header className='lis_paren_side_accordion px-0 py-2' id="privatesale_parent">
                                        <Accordion.Toggle as={Button} variant="link" eventKey="1" className='w-100 pl-0'>
                                            <div className='d-flex align-items-center justify-content-between pl-0'>
                                                <div className='icon_text_div pl-2' >
                                                    <img src={privateicon} className="icon_sidebar" />
                                                    <span>
                                                        Private Sale
                                                    </span>
                                                </div>
                                                <button className='btn_white_outline_round'>
                                                    <i class="fa fa fa-angle-down" aria-hidden="true"></i>
                                                </button>
                                            </div>

                                        </Accordion.Toggle>
                                    </Card.Header>
                                    <Accordion.Collapse eventKey="1">
                                        <Card.Body className='py-0 inner_card_body_acc'>
                                            <ul className='sidebar_inner_ul pl-3'>
                                                <NavLink to="/createprivatesale">
                                                    <li className='li_bot_less'>
                                                        Create Private Sale
                                                    </li>
                                                </NavLink>
                                                <NavLink to="/privatesalelist">
                                                    <li className='li_bot_less'>
                                                        Private Sale List

                                                    </li>
                                                </NavLink>

                                            </ul>
                                        </Card.Body>
                                    </Accordion.Collapse>
                                </Card>

                                <Card>
                                    <Card.Header className='lis_paren_side_accordion px-0 py-2' id="lock_parent">
                                        <Accordion.Toggle as={Button} variant="link" eventKey="2" className='w-100 pl-0'>
                                            <div className='d-flex align-items-center justify-content-between pl-0'>
                                                <div className='icon_text_div pl-2' >
                                                    <img src={lockedicon} className="icon_sidebar" />
                                                    <span>
                                                        In Lock
                                                    </span>
                                                </div>
                                                <button className='btn_white_outline_round'>
                                                    <i class="fa fa fa-angle-down" aria-hidden="true"></i>
                                                </button>
                                            </div>

                                        </Accordion.Toggle>
                                    </Card.Header>
                                    <Accordion.Collapse eventKey="2">
                                        <Card.Body className='py-0 inner_card_body_acc'>
                                            <ul className='sidebar_inner_ul pl-3'>
                                                <NavLink to="/createlock">
                                                    <li className='li_bot_less'>
                                                        Create Lock
                                                    </li>
                                                </NavLink>
                                                <NavLink to="/createlplock">
                                                    <li className='li_bot_less'>
                                                        LP Token Lock
                                                    </li>
                                                </NavLink>
                                                <NavLink to="/tokenlock">
                                                    <li className='li_bot_less'>
                                                        Token Lock
                                                    </li>
                                                </NavLink>



                                            </ul>
                                        </Card.Body>
                                    </Accordion.Collapse>

                                </Card>

                                <Card>
                                    <Card.Header className='lis_paren_side_accordion px-0 py-2' id="airdrop_parent">
                                        <Accordion.Toggle as={Button} variant="link" eventKey="4" className='w-100 pl-0'>
                                            <div className='d-flex align-items-center justify-content-between pl-0'>
                                                <div className='icon_text_div pl-2' >
                                                    <img src={airicon} className="icon_sidebar" />
                                                    <span>
                                                        Air Drops
                                                    </span>
                                                </div>
                                                <button className='btn_white_outline_round'>
                                                    <i class="fa fa fa-angle-down" aria-hidden="true"></i>
                                                </button>
                                            </div>

                                        </Accordion.Toggle>
                                    </Card.Header>
                                    <Accordion.Collapse eventKey="4">
                                        <Card.Body className='py-0 inner_card_body_acc'>
                                            <ul className='sidebar_inner_ul pl-3'>
                                                <NavLink to="/createairdrop">
                                                    <li className='li_bot_less'>
                                                        Create Airdrop
                                                    </li>
                                                </NavLink>
                                                <NavLink to="/airdroplist">
                                                    <li className='li_bot_less'>
                                                        Airdrop List
                                                    </li>
                                                </NavLink>

                                            </ul>
                                        </Card.Body>
                                    </Accordion.Collapse>
                                </Card>

                                <hr className='hrsidebar'/>
                                <h4 className='explore mt-4 mb-3'>DEVELOPERS</h4>
                                <Card>
                                    <Card.Header className='lis_paren_side_accordion px-0 py-2' id="createlaunch_parent">
                                        <Accordion.Toggle as={Button} variant="link" eventKey="7" className='w-100 pl-0'>
                                            <div className='d-flex align-items-center justify-content-between pl-0'>
                                                <div className='icon_text_div pl-2' >
                                                    <img src={createlaunch} className="icon_sidebar" />
                                                    <span>
                                                        Create & Launch
                                                    </span>
                                                </div>
                                                <button className='btn_white_outline_round'>
                                                    <i class="fa fa fa-angle-down" aria-hidden="true"></i>
                                                </button>
                                            </div>

                                        </Accordion.Toggle>
                                    </Card.Header>
                                    <Accordion.Collapse eventKey="7">
                                        <Card.Body className='py-0 inner_card_body_acc'>
                                            <ul className='sidebar_inner_ul pl-3'>
                                                <NavLink to="/create" onClick={() => { this.setState({ setActive: 1 }) }}>
                                                    <li className='li_bot_less'>
                                                        Create Launchpad
                                                    </li>
                                                </NavLink>
                                            
                                                <NavLink to="/createprivatesale">
                                                    <li className='li_bot_less'>
                                                        Create Private Sale
                                                    </li>
                                                </NavLink>
                                                <NavLink to="/createairdrop">
                                                    <li className='li_bot_less'>
                                                        Create Airdrop
                                                    </li>
                                                </NavLink>
                                            </ul>
                                        </Card.Body>
                                    </Accordion.Collapse>
                                </Card>

                                <Card>
                                    <Card.Header className='lis_paren_side_accordion px-0 py-2' id="createlaunch_parent">
                                        <Accordion.Toggle as={Button} variant="link" eventKey="8" className='w-100 pl-0'>
                                            <div className='d-flex align-items-center justify-content-between pl-0'>
                                                <div className='icon_text_div pl-2' >
                                                    <img src={utility} className="icon_sidebar" />
                                                    <span>
                                                        Utility & Tools
                                                    </span>
                                                </div>
                                                <button className='btn_white_outline_round'>
                                                    <i class="fa fa fa-angle-down" aria-hidden="true"></i>
                                                </button>
                                            </div>

                                        </Accordion.Toggle>
                                    </Card.Header>
                                    <Accordion.Collapse eventKey="8">
                                        <Card.Body className='py-0 inner_card_body_acc'>
                                            <ul className='sidebar_inner_ul pl-3'>
                                                <NavLink to="/createtoken">
                                                    <li className='li_bot_less'>
                                                        Token Creation
                                                    </li>
                                                </NavLink>
                                                <NavLink to="/tokenlock">
                                                    <li className='li_bot_less'>
                                                        Token Lock
                                                    </li>
                                                </NavLink>
                                                <NavLink to="/createlplock">
                                                    <li className='li_bot_less'>
                                                        LP Token Lock
                                                    </li>
                                                </NavLink>
                                            </ul>
                                        </Card.Body>
                                    </Accordion.Collapse>
                                </Card>


                            </Accordion>


                        </li>



                        {/* <NavLink to="/leaderboardlist" className="parent_1_grad">
                <li className='lis_paren_side'>
               
                <img src={leadershipicon} className="icon_sidebar" />
                <span>
                    Leaderboard
                </span>
               
                </li>
                </NavLink> */}

                        {/* <NavLink to="/multisender" className="parent_1_grad">
                <li className='lis_paren_side'>
               
                <img src={sendericon} className="icon_sidebar" />
                <span>
                    Multi-Sender
                </span>
               
                </li>
                </NavLink> */}
                        {/* <NavLink to="/kyc" className="parent_1_grad">
                        <li className='lis_paren_side'>

                            <img src={kycicon} className="icon_sidebar" />
                            <span>
                                KYC
                            </span>

                        </li>
                    </NavLink> */}

                        {/* <a href="https://bitdealz.exchange/" target='_blank' className="parent_1_grad">
                        <li className='lis_paren_side'>

                            <img src={exchange} className="icon_sidebar" />
                            <span>
                                Exchange
                            </span>

                        </li>
                    </a> */}


                        {/* <a target="_blank" href="https://docs.cryptolaunchpad.finance/" className="parent_1_grad">
                <li className='lis_paren_side'>
               
                <img src={docsicon} className="icon_sidebar" />
                <span>
                <a href="https://www.dexview.com/" target="_blank" className='inside_span_a'>
                   dexview.com
                </a>
                </span>
               
                </li>
                </a> */}

                        {/* <a href="/" target="_blank" className="parent_1_grad">
                        <li className='lis_paren_side'>
                            <img src={docsicon} className="icon_sidebar" />
                            <span>
                               Docs
                            </span>

                        </li>
                    </a> */}

                        {/* <a href={this.state.telegram.settingvalue} target="_blank" className="parent_1_grad"> */}
                        {/* <a href="/" target="_blank" className="parent_1_grad">
                        <li className='lis_paren_side'>

                            <img src={telegramicon} className="icon_sidebar" />
                            <span>
                                Telegram
                            </span>

                        </li>
                    </a> */}

                        {/* <a href={this.state.twitter.settingvalue} target="_blank" className="parent_1_grad"> */}
                        {/* <a href="/" target="_blank" className="parent_1_grad">
                        <li className='lis_paren_side'>

                            <img src={twittericon} className="icon_sidebar" />
                            <span>
                                Twitter
                            </span>

                        </li>
                    </a> */}

                        {/* <a href={this.state.facebook.settingvalue} target="_blank" className="parent_1_grad"> */}
                        {/* <a 
                    // href={this.state.facebook.settingvalue} 
                    href='/'
                    target="_blank" className="parent_1_grad">
                        <li className='lis_paren_side'>

                            <img src={discordicon} className="icon_sidebar" />
                            <span>
                                Discord
                            </span>

                        </li>
                    </a> */}

                        {/* <div className='feature text-center mt-3'>
                            <h5 className='mb-3 featuredby'>Featured By</h5>
                            <img src={`${API_URL}/public/cms_images/${this.state.image}`} className='demoimg  img-fluid' alt='demoimg' />
                            <div className='d-flex justify-content-center mt-3 mb-4'>
                                <div className='socialmedia'>
                                    <a href={this.state.telegram} target='_blank'><img src={teles} className='soicon' alt='img' /></a>
                                </div>
                                <div className='ml-4 socialmedia'>
                                    <a href={this.state.Twitter} target='_blank'><img src={skypes} className='soicon' alt='img' /></a>
                                </div>

                            </div>
                        </div> */}

                    </ul>
                    <div className='footer_theme_div lighthemess'>

                        {/* <NavLink to="/crypto" className="parent_1_grad">
                            <div className='lis_paren_side_cry'>

                                <img src={coinsicon} className="icon_sidebar" />
                                <span>
                                    Crypto $0.03
                                </span>

                            </div>
                        </NavLink> */}

                        <div className='icon_theme_div'>
                            <i className="fa fa-sun-o theme_icon" aria-hidden="true" id="sun_icon" onClick={() => this.lightTheme()}></i>
                            {/* <span className='px-1 text_splash'>/</span> */}
                            <i class="fa fa-moon-o theme_icon ml-5 active" aria-hidden="true" id="moon_icon" onClick={() => this.darkTheme()}></i>
                            {/* <span className='pl-2 text_splash mode_taxt'>Mode</span> */}
                        </div>
                    </div>

                </div>

                <div id="footer_side">
                    <div className='footer_menu_flex_side mb-0' >
                        {/* <NavLink to="/">
                            <img src={homeicon} className="icon_sidebar_bototm" />
                        </NavLink>
                        <a href="/" target='_blank'>
                            <img src={exchangeicon} className="icon_sidebar_bototm" />
                        </a> */}

                        <button className="btn_bar_mobl p-0" onClick={() => this.setSidebarWidth()}>
                            <MdOutlineMenu fontSize={37}/>
                            {/* <img src={bar_img_white} className='img-fluid img_bar' /> */}
                            {/* <i class="fa fa-bars" aria-hidden="true"></i> */}
                        </button>
                    </div>
                </div>

            </>
        );
    }
}



export default Sidebar